import React, { Component } from "react";
import { connect } from "react-redux";
import "./Sidebar.css";
import { withRouter } from "react-router";

import { Layout } from "antd";
import PublicView from "./Views/PublicView";
import ReferentView from "./Views/ReferentView";
import KorisnikView from "./Views/KorisnikView";
import axiosInstance from "../../api/utils/axiosInstance"
const { Sider } = Layout;

class Sidebar extends Component {
  state = {
    collapsed: false,
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };
  // PREUZIMANJE KORISNICKE UPUTE
  downloadUputa = async () => {
    try {
      const res = await axiosInstance.get("/korisnickaUputa/vanjski", {
        method: "get",
        responseType: "blob",
      });
      const file = new Blob([res.data], {
        type: "application/pdf"
      });
      let a = document.createElement("a");
      document.body.appendChild(a);
      let fileUrl = URL.createObjectURL(file);
      a.href = fileUrl;
      a.download = 'korisnickaUputa.pdf';
      a.click();
    } catch (e) {
      throw e;
    }
  };
  // PREUZIMANJE KORISNICKE UPUTE ADMINISTRATOR
  downloadUputaAdministrator = async () => {
    try {
      const res = await axiosInstance.get("/korisnickaUputa/minf", {
        method: "get",
        responseType: "blob",
      });
      const file = new Blob([res.data], {
        type: "application/pdf",
      });
      let a = document.createElement("a");
      document.body.appendChild(a);
      let fileUrl = URL.createObjectURL(file);
      a.href = fileUrl;
      a.download = 'korisnicka_uputa_za_sluzbenike.pdf';
      a.click();
      //  window.open(fileUrl);
    } catch (e) {
      throw e;
    }
  };



  render() {
    const { isAuthenticated, userRole, subjectOib, oib } = this.props;

    const checkIfUserIsAdmin =
      userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";


    return (
      <Sider
        collapsible
        collapsed={this.state.collapsed}
        onCollapse={this.onCollapse}
        width={260}
      >
        {isAuthenticated ? (
          <>
            {checkIfUserIsAdmin && <ReferentView isSubject={subjectOib && oib !== subjectOib || false} {...this.props} downloadUputa={this.downloadUputa} downloadUputaAdministrator={this.downloadUputaAdministrator} />}
            {userRole == "ROLE_KORISNIK" && <KorisnikView isSubject={subjectOib && oib !== subjectOib || false} {...this.props} downloadUputa={this.downloadUputa} />}
          </>
        ) : (
          <PublicView {...this.props} downloadUputa={this.downloadUputa} />
        )}
      </Sider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userRole: state.authentication.userData
      ? state.authentication.userData.roles[0].roleName
      : "",
    oib: state.authentication.userData?.oib,
    subjectOib: state.authentication.subjectOib,
    isAuthenticated: state.authentication.isAuthenticated,
  };
};

export default withRouter(connect(mapStateToProps)(Sidebar));
